import React from "react";
import { useTranslation } from "react-i18next";

export default function LanguageToggle() {
  const { i18n, t } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "zh";
  const setLang = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("jl_lang", lng);
  };
  return (
    <div
      className="inline-flex items-center rounded-full border border-[#e5ebeb] bg-white p-1 text-xs"
      data-testid="language-toggle"
    >
      <button
        className={`px-3 py-1 rounded-full font-medium transition-colors duration-200 ${
          current === "zh"
            ? "bg-[#005870] text-white"
            : "text-[#4a6e77] hover:text-[#003645]"
        }`}
        onClick={() => setLang("zh")}
        data-testid="lang-zh-btn"
      >
        {t("common.zh")}
      </button>
      <button
        className={`px-3 py-1 rounded-full font-medium transition-colors duration-200 ${
          current === "en"
            ? "bg-[#005870] text-white"
            : "text-[#4a6e77] hover:text-[#003645]"
        }`}
        onClick={() => setLang("en")}
        data-testid="lang-en-btn"
      >
        {t("common.en")}
      </button>
    </div>
  );
}
